'use client';
import { Share2 } from 'lucide-react';
import React, { useState } from 'react';

import { ClipboardIcon } from '../../icons/ClipboardIcon';
import { FacebookIcon } from '../../icons/FacebookIcon';
import { TwitterIcon } from '../../icons/TwitterIcon';

const ShareButton = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handleShare = () => {
    if (navigator.share) {
      navigator
        .share({
          title: 'AllBlogs',
          url: window.location.href,
        })
        .catch(err => console.error('Error sharing:', err));
    } else {
      setIsOpen(!isOpen);
    }
  };

  return (
    <div className="relative">
      <button
        onClick={handleShare}
        className="flex items-center text-gray-600 hover:text-blue-500 dark:text-gray-400"
        aria-label="Share"
      >
        <Share2 className="h-5 w-5" />
      </button>
      {isOpen && (
        <div className="ring-opacity-5 absolute top-8 right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white p-2 shadow-lg ring-1 ring-black dark:bg-gray-800">
          <div className="flex flex-col gap-2">
            <a
              href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(window.location.href)}`}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 rounded-md px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700"
            >
              <TwitterIcon className="h-4 w-4 text-blue-400" />
              Share on Twitter
            </a>
            <a
              href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.href)}`}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 rounded-md px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700"
            >
              <FacebookIcon className="h-4 w-4 text-blue-600" />
              Share on Facebook
            </a>
            <button
              onClick={() => {
                navigator.clipboard.writeText(window.location.href);
                setIsOpen(false);
              }}
              className="flex items-center gap-2 rounded-md px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700"
            >
              <ClipboardIcon />
              Copy Link
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ShareButton;
